docCache